import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { BackToWorkspace } from "../Sections/BackToWorkspace";
import { setTrackingId } from "client/Misc/utils";

export const Forbidden = (): ReactElement => {
	return (
		<>
			<h2 {...setTrackingId("error-code|403")}>{localize("_Error403")}</h2>
			<BackToWorkspace />
		</>
	);
};
Forbidden.displayName = "Forbidden";